<template lang="pug">
nav#navbar.navbar.is-fixed-top(role="navigation", aria-label="main navigation")
  .container
    .navbar-brand
      router-link.navbar-item(to="/")
        i.signet(width="28", height="28")
        span.is-size-5.has-text-weight-semibold(place="wb") {{ $t('topNav.wb') }}
        span.is-size-5.is-hidden-mobile(place="dig") {{ $t('topNav.digital') }}
      .navbar-burger(data-target="menu")
        span
        span
        span
    #menu.navbar-menu.navbar-end
      a.navbar-item.has-text-weight-semibold.is-hidden-touch(:class="{'is-hidden-homepage': isHomepage}" @click="toggleSearchForm"): i.fa.fa-search
      router-link.navbar-item.has-text-weight-semibold(:to="links.toc.edition" @click.native="deActivateNavBarBurger") {{ $t("topNav.editions") }}
      router-link.navbar-item.has-text-weight-semibold(:to="links.toc.archiv" @click.native="deActivateNavBarBurger") {{ $t("topNav.archives") }}
      router-link.navbar-item.has-text-weight-semibold(:to="links.toc.project" @click.native="deActivateNavBarBurger") {{ $t("topNav.projects") }}
      router-link.navbar-item.has-text-weight-semibold(v-if="showTranslations" :to="links.toc.translation" @click.native="deActivateNavBarBurger") {{ $t("topNav.translations") }}
      router-link.navbar-item.has-text-weight-semibold(to="/personen" @click.native="deActivateNavBarBurger") {{ $t("topNav.persons") }}
      //- the search form for mobile devices
      search-form(context="mobile" v-bind:isHomepage="isHomepage" v-bind:permanent="false")
</template>

<script>
import SearchForm from "../search/SearchForm";

const { mapState } = require("vuex");
const { messages } = require("../../i18n/top-nav");
const throttle = require ("lodash.throttle");

export default {
    name: "TopNav",
    components: {
        SearchForm
    },
    i18n: {
        messages
    },

    computed: {
        isHomepage: function() {
            return this.$route.name === "home"
        },

        currentRouteIsTranscriptRoute: function() {
            return this.$route.name === "transcript"
        },

        ...mapState("transcript", ["displayFacsimileBundle", "displayTranscriptToc"]),
        ...mapState("search", ["searchFormMessageBus"])
    },

    data() {
        return {
            visible: true,
            links: {
                persons: { name: "persons" },
                about: { name: "home"},
                toc: {
                    edition: { name: "toc", params: {section: "edition" }},
                    archiv: { name: "toc", params: {section: "archiv" }},
                    project: { name: "toc", params: {section: "projekte" }},
                    translation: { name: "translations" }
                }
            },
            prevScrollY: window.scrollY,
            // HACK: security through obfuscation; this is actually not secure
            showTranslations: ["localhost", "wbwun.pagina-dh.de"].includes(window.location.hostname)
        };
    },

    methods: {
        deActivateNavBarBurger() {
            const html = document.documentElement;
            const navbar = document.querySelector(".navbar");
            const navbarBurger = navbar.querySelector(".navbar-burger");
            const target = document.getElementById(navbarBurger.dataset.target);

            [target, navbarBurger].forEach(el => el.classList.remove("is-active"));
            html.classList.remove("has-navbar-menu-active");
        },

        toggleSearchForm() {
            this.searchFormMessageBus.$emit("ToggleSearchForm");
        }
    },

    mounted() {
        const html = document.documentElement;
        html.classList.add(this.htmlclass);
        const navbar = document.querySelector(".navbar");

        window.addEventListener("scroll", throttle(() => handleScrolling(this, navbar), 500));

        const navbarBurger = navbar.querySelector(".navbar-burger");
        const target = document.getElementById(navbarBurger.dataset.target);

        navbarBurger.addEventListener("click", (e) => {
            e.preventDefault();
            [target, navbarBurger].forEach(el => el.classList.toggle("is-active"));
            html.classList.toggle("has-navbar-menu-active");
        });
    }
}

function handleScrolling(vueModel, navbar) {

    const navbarHeight = navbar.offsetHeight;

    const { scrollY } = window;
    if (scrollY != vueModel.prevScrollY) {
        // because of a tipping effect on mobile devices, we need to ignore small downward bound scrolls towards the top of the page
        const y = -(scrollY < navbarHeight || scrollY < vueModel.prevScrollY ? 0 : navbarHeight);
        transformNavbar(navbar, y);
        const menu = document.getElementById("menu");
        menu.classList.remove("is-active");
        vueModel.prevScrollY = scrollY;
    }
}

function transformNavbar(navbar, y) {
    navbar.style = `transform: translateY(${y}px);transition: transform 0.5s`;
}
</script>